module.exports = __webpack_public_path__ + "img/icon-alert-hight-outline.2c606bba.svg";